import "intersection-observer";
import * as React from "react";
import { Updater, IOWidget, fromJSX } from "widgets-for-react";
import { CMSState, ImageSize } from "../types.gen";

export type MediaBlockNestedProps = {
  index: number
  items: MediaItemNestedProps[]
}

export type MediaItemNestedProps = {
  kind: "image" | "video"
  image?: number
  image_alt?: string
  size?: ImageSize
  get_default_data_src:(() => ImageSize)
  get_default_data_srcset:(() => [ImageSize, string][])
  video?: { url: string } & {
    id: string
    type: string
    width: string
    height: string
    frameBorder: string
    allowFullScreen: boolean
  }
  caption?: string
  source?: string
  useCookieBar: boolean
  cookiePlaceholder: JSX.Element | string
  cookieButton: string
}

// NOT USED!!!
export function MediaBlockNested(
  props: MediaBlockNestedProps,
): IOWidget<CMSState, Updater<CMSState>> {
  return (cmsState: CMSState) =>
    fromJSX(() => {
        return <></>      }
    )
}
